import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa';
import CabinSummary from './CabinSummary';
import { CartContext, guestTypes } from '../../Context/CartContext';
import GuestDetails from './GuestDetails';
import OrderSummary from './OrderSummary';
import NumberFormat from 'react-number-format';

function Booking(props) {
  const formClass = "w-full p-4 bg-gray-100";
  const formStyle = { minHeight: 'calc(100vh - 230px)' };
  const [cart, setCart] = useContext(CartContext);
  const [currentStep, setCurrentStep] = useState(0);
  const [cruiseMaster, setCruiseMaster] = useState({});
  const [search, setSearch] = useState();
  const [passengerChanged, setPassengerChanged] = useState({ cabinIndex: null, passengerType: "" });
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);

  function hasEqualPersons(obj1, obj2) {
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);

    for (let objKey of obj1Keys) {
      if (objKey != "cabintypeId" && obj2Keys.includes(objKey)) {
        if (obj1[objKey] != obj2[objKey]) {
          return false;
        }
      }
    }

    return true;
  }
  function updatePrice() {
    const updatedCart = { ...cart };
    const cabin = updatedCart.cabins[passengerChanged.cabinIndex];
    const cp = cruiseMaster.cruisePackages.find(x => x.id === updatedCart.packageId);
    const grid = cp.priceGrids.find(x => hasEqualPersons(x, cabin));
    if (grid) {
      const row = grid.priceGridRows.find(x => x.cabinCategoryPrimaryTypeId === cabin.cabintypeId);
      if (row) {
        cabin.price = row.priceGridCell.lowestPrice / 100;
        setCart(updatedCart);
      }
    }
  }
  function nextStep(event) {
    event.preventDefault();
    setCurrentStep(currentStep + 1);
  }
  function previousStep() {
    setCurrentStep(currentStep - 1);
  }
  function renderCurrentStep() {
    switch (currentStep) {
      case 0:
        return <div className={formClass} style={formStyle}>
          <div className="mx-auto w-10/12" >
            <CabinSummary
              master={cruiseMaster}
              onPassengerChange={handlePassengerChange}
            />
            <form onSubmit={nextStep}>
              <div className="text-right py-8 ">
                <input className="bg-cruise_orange py-1 w-48 text-cruise_darkblue"
                  type="submit" value="Confirm" />
              </div>
            </form>
          </div>
        </div>
        break;
      case 1:
        return <div className={formClass} style={formStyle}>
          <form onSubmit={nextStep}>
            <div>
              <div className="flex justify-center">
                <div className="mr-4">
                  <GuestDetails />
                </div>
                <div>
                  <OrderSummary />
                </div>
              </div>
              <div className="flex justify-around py-8">
                <button className="bg-cruise_orange py-1 w-48 text-cruise_darkblue" onClick={previousStep}>Back</button>
                <input className="bg-cruise_orange py-1 w-48 text-cruise_darkblue" type="submit" value="To payment" />
              </div>
            </div>
          </form>
        </div>
        break;
    }
  }
  function total() {
    let t = cart.cabins.reduce((a, b) => +a + b.price, 0);
    return parseInt(t);
  }
  function addGuests(guestArr, numberOfGuest, guestType) {
    const defaultGuest = {
      guestType: null,
      title: 0,
      firstName: "",
      lastName: "",
      dateOfBirth: null,
      nationality: "",
    };
    for (var i = 0; i < numberOfGuest; i++) {
      const newGuest = { ...defaultGuest };
      newGuest.guestType = guestType;
      guestArr.push(newGuest);
    }
  }
  function renderDuration() {
    const from = new Date(cart.departure);
    const to = new Date(cart.departure);
    to.setDate(to.getDate() + cart.duration);
    return <span>
      {new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long"
      }).format(from)}
      &nbsp;-&nbsp;
      {new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long"
      }).format(to)}&nbsp;
      ({cart.duration} nights)
    </span>
  }
  function renderPrice(price) {
    return <NumberFormat
      value={price}
      decimalScale={0}
      displayType={'text'}
      decimalSeparator={','}
      thousandSeparator={'.'}
      prefix={'DKK '}
    />
  }
  function handlePassengerChange(name, value, cabinIndex) {
    const updatedCart = { ...cart };
    updatedCart.cabins[cabinIndex][name] = value;
    setCart(updatedCart);
    const updatedSearch = { ...search };
    updatedSearch.cabins[cabinIndex].persons[name] = value;
    setSearch(updatedSearch);

    // keep the change temporarily for when the new price is recieved...
    const changedPassenger = { ...passengerChanged };
    changedPassenger.cabinIndex = cabinIndex;
    changedPassenger.passengerType = name;
    setPassengerChanged(changedPassenger);
  }

  useEffect(() => {
    setLoading(true);
    // add default guests to the Cart...
    const updatedCart = { ...cart };
    const mainGuest = {
      title: 0,
      firstName: "",
      lastName: "",
      dateOfBirth: null,
      nationality: "",
      email: "",
      phone: "",
      address:
      {
        street: "",
        city: "",
        zipCode: ""
      },
      createProfile: true,
    };

    updatedCart.cabins.map((cabin) => {
      cabin.mainGuest = { ...mainGuest };
      const guests = [];
      if (cabin.adults > 1) {
        addGuests(guests, cabin.adults - 1, guestTypes.adult);
      }
      addGuests(guests, cabin.seniors, guestTypes.senior);
      addGuests(guests, cabin.children, guestTypes.child);
      addGuests(guests, cabin.juniorChildren, guestTypes.juniorchild);
      addGuests(guests, cabin.infants, guestTypes.infant);
      cabin.additionalGuests = guests;
    });

    setCart(updatedCart);

    let path = `/api/proxy/Details?tokenstring=${encodeURIComponent(props.match.params.token)}`;
    path += `&id=${encodeURIComponent(props.match.params.masterid)}`;

    fetch(path)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((result) => {
        setCruiseMaster(result.content);
        setSearch(result.search);
        setLoading(false);
      })
      .catch(err => {
        setHasError(true);
      });
  }, []);
  useEffect(() => {
    if (loading) {
      return;
    }
    var searchurl = `/api/proxy/Details?id=${encodeURIComponent(props.match.params.masterid)}`;

    fetch(searchurl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(search)
    })
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((result) => {
        setCruiseMaster(result.content);
      })
      .catch(err => {
        debugger;
        setHasError(true);
      });
  }, [passengerChanged]);
  useEffect(() => {
    if (!loading) {
      updatePrice();
    }
  }, [cruiseMaster]);

  if (loading) {
    return <div>loading...</div>
  }

  return (
    <div className="flex flex-col items-center">
      <div className="flex justify-between items-center bg-cruise_darkblue w-full p-5 text-white text-base sticky top-0 z-10">
        <div className="flex justify-between w-3/5 items-center">
          <Link
            to={"/details/" + props.match.params.token + "/" + cart.masterId}
            className="text-white px-2 py-1 hover:no-underline hover:bg-primary-button-hover hover:text-black">
            <span className="flex items-center"><FaAngleLeft size={18} /> Back</span>
          </Link>
          <div>
            <div>{cart.name}</div>
            <div>{renderDuration()}</div>
          </div>
          <div>
            <div>{cart.cruiseline}</div>
            <div>{cart.ship}</div>
          </div>
        </div>
        <div className="flex flex-col items-end">
          <div>{renderPrice(total())}</div>
          <div>total</div>
        </div>
      </div>
      {renderCurrentStep()}
    </div>
  );
}

export default Booking;